import ImportarSiembras from './ImportarSiembras';

export default function ImportarDatos() {
  return (
    <div className="flex flex-col h-full">
      <div className="bg-white border-b shadow-sm">
        <div className="px-6 py-5">
          <h1 className="text-3xl font-bold text-primary mb-1">Importar Datos</h1>
          <p className="text-sm text-gray-500">
            🌱 Importación de siembras desde Excel
          </p>
        </div>
      </div>

      <div className="flex-1 overflow-auto">
        <ImportarSiembras />
      </div>
    </div>
  );
}